export default __webpack_public_path__ + "static/srb-067aab7b6c6f584df0f536f304ec7454.svg";